export const APP_API_URL = process.env.NEXT_PUBLIC_APP_API_URL as string
export const SIGNUP_HOST = process.env.NEXT_PUBLIC_SIGNUP_HOST as string
export const HOST = process.env.NEXT_PUBLIC_HOST as string
export const GOOGLE_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_API_KEY as string
export const TRUSTDOCK_PLAN_ID = process.env.NEXT_PUBLIC_TRUSTDOCK_PLAN_ID as string
export const TRUSTDOCK_CORE_SCRIPT =
  process.env.NEXT_PUBLIC_APP_ENV === 'production'
    ? 'https://helper.trustdock.io/v2/verification_helper.js'
    : 'https://helper.test.trustdock.io/v2/verification_helper.js'
export const COMPANY_VIOLATION_REPORT_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSe7PTqV2a7gBcGOB-B-aHLvomzwrznuU90fAM1_lL-mf8ovQQ/viewform'
export const TERMS_URL = 'https://gigbase.jp/terms' as const
export const PRIVACY_POLICY_URL = 'https://gigbase.jp/personal' as const
